export enum DeploymentStatus {
  Null = 'Null',
  Success = 'Success',
  Failure = 'Failure',
  Deploying = 'Deploying'
}

export type DeploymentInfo = {
  domain: string;
  status: DeploymentStatus;
  masterVersion: string;
};

export function deploymentInfoToLocal(res: any) {
  return {
    domain: res.domain,
    status: res.status,
    masterVersion: res.master_version
  };
}


export type ChannelConfigMeta = {
  id?: string;
  channel_type: string;
  class_name: string;
  meta_data: string;
};
